async function updateCartBrandAttribute(currentBrand) {
  try {
    if (!currentBrand) currentBrand = "brand1";

    const res = await fetch("/cart.js");
    const cart = await res.json();

    const existingBrand = cart.attributes?.brand;

    if (existingBrand !== currentBrand) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          attributes: { brand: currentBrand },
        }),
      });
    }
  } catch (err) {
    console.warn("Failed to update cart brand attribute:", err);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const currentBrand = window.__CURRENT_BRAND__;
  updateCartBrandAttribute(currentBrand);
});
